/**
 * Formatage monétaire fr-TN (millimes ↔ TND).
 */

export const MILLIMES_PER_TND = 1000;

export function formatMillimes(millimes: number, opts: { withSymbol?: boolean } = {}): string {
  const tnd = millimes / MILLIMES_PER_TND;
  const formatter = new Intl.NumberFormat('fr-TN', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  const formatted = formatter.format(tnd);
  return opts.withSymbol === false ? formatted : `${formatted} TND`;
}

export function tndStringToMillimes(s: string): number {
  // Accepts "1234.567" or "1 234,567" or "1234,567" → 1234567
  const cleaned = s.replace(/\s/g, '').replace(',', '.');
  const tnd = parseFloat(cleaned);
  if (Number.isNaN(tnd)) return 0;
  return Math.round(tnd * MILLIMES_PER_TND);
}
